
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import LogUtils from 'panda-log';
import SignInRulevue from './_SignInRule.vue';
import { eRewardType, iCheckIn } from '@/interface/prize';
import { day } from '@/utils/common';

@Component({
  components: { SignInRulevue },
})
export default class signModal extends Vue {
  @Prop() private visible!: boolean;
  @Emit() private close() {
    // console.log('close');
  }
  @Prop() private signIn!: iCheckIn;
  coinType = eRewardType.COIN;
  freeTimeType = eRewardType.FREE;
  weekType = eRewardType.WEEKCARD;
  cashType = eRewardType.CASH;
  // 任务状态  1-未完成 2-已完成 3-已领取
  private ruleVisible: boolean = false; //规则
  // 分享领币
  @Emit() private share() {
    // LogUtils.info('分享领币');
  }
  getUnit(type: eRewardType) {
    switch (type) {
      case this.freeTimeType:
        return '体验时长';
      case this.cashType:
        return '现金券';
      case this.weekType:
        return '周期卡';
    }
    return '';
  }
  /* 规则 */
  handlerRule() {
    this.ruleVisible = true;
    LogUtils.info('规则');
  }
  getDay(num: number) {
    return day[num - 1];
  }
  mounted() {}
}
